export const iconFontAwesomeAutomotiveCar = (
	<i className="fa-solid fa-car"></i>
);
